import { Table } from 'react-bootstrap';
import GetDataApi from '../../../Components/Common/FetchData/GetDataApi';
import PopOver from '../../../Components/PopOver/PopOver';
import DeleteDataApi from '../../../Components/Common/FetchData/DeleteDataApi';
import { useEffect, useState } from 'react';
import ProductDetailsWithModal from '../../PublicProductAndServices/ProductDetailsWithModal';
import { IProduct } from '../../../Types/ProductTypes';
import { FaEye } from 'react-icons/fa';
import { IWishList } from '../apiEndpoints/visitorType';

const B2BWishlist = () => {
  const [data, setData] = useState<IWishList>();
  const [show, setShow] = useState(false);
  const { response, getData } = GetDataApi<IWishList[]>(
    '/api/fair/visitor/wishlist',
    true
  );
  const { deleteData, success, setSuccess } = DeleteDataApi(
    '/api/fair/visitor/wishlist'
  );

  useEffect(() => {
    if (success) {
      getData();
      setSuccess(false);
    }
    getData();
  }, [success]);
  return (
    <>
      <div className='profile-right-side px-3 py-3'>
        <h4 className='component-tittle'>Wishlist</h4>

        <Table striped bordered hover>
          <thead>
            <tr className='text-center'>
              <th>SL.</th>
              <th>Company Name</th>
              <th>Product Name</th>
              <th>Category</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {response?.length ? (
              <>
                {response?.map((wishlist, index) => {
                  return (
                    <tr className='text-center' key={wishlist.id}>
                      <td>{index + 1}</td>
                      <td>{wishlist?.user_fair_member_company_name}</td>
                      <td>{wishlist?.fair_member_product_name}</td>
                      <td>{wishlist.fair_member_product_category}</td>
                      <td>{wishlist.fair_member_product_price}</td>
                      <td>
                        <span
                          className='pointer'
                          onClick={() => {
                            setShow(!show);
                            setData(wishlist);
                          }}
                        >
                          <FaEye color='#00acee' />
                        </span>
                        <PopOver
                          confirm={() => {
                            deleteData(wishlist?.id);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <tr className='text-center'>
                <td colSpan={5} className='fw-bold'>
                  No register event found!
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <ProductDetailsWithModal show={show} setShow={setShow} data={data} />
    </>
  );
};

export default B2BWishlist;
